<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} VIDEO CONTENT</template>
		<template #body>
			
					<div class="form-floating mb-4">
						<select v-model="form.category" class="form-select">
							<option value="">Select Category</option>
							<optgroup v-for="(category,index) in categories" :label="index">
								<option
									v-for="(cat,c_index) in category"
									:key="c_index"
									:value="c_index"
								>
									{{ cat }}
								</option>
							</optgroup>
						</select>
						<label class="form-label" for="category">Category</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.title" id="title" name="title" class="form-control" placeholder="Title" />
						<label class="form-label" for="title">Title</label>
					</div>
					<div class="form-floating mb-4">
						<textarea v-model="form.description" id="description" class="form-control" placeholder="Enter Description" style="height:150px;"></textarea>
						<label class="form-label" for="description">Description</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.video_id" id="video_id" name="video_id" class="form-control" placeholder="Video ID" />
						<label class="form-label" for="video_id">Video ID</label>
					</div>
					<div v-if="form.category!='home_video_feature'" class="form-floating mb-4">
						<div class="mb-4">
							<label class="form-label" for="video_img">Video Image</label>
							<div class="fw-bold text-danger">Recommended Size: width:424px height:261px</div>
							<input
								@change="onFileChange"
								type="file"
								id="video_img"
								name="video_img"
								class="form-control"
								:accept="[
					            'image/jpeg',
					            'image/jpg',
					            'image/png'
					          ]"
							/>
						</div>
						<div class="mb-4">
							<div v-if="form.prev_video_img!=null"
								class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
								style="
									height: 300px;
									background-size: contain;
									background-repeat: no-repeat;
									background-position: center;
								"
								:class="{'opacity-25':(form.video_img!=form.prev_video_img && form.prev_video_img!=null && action=='update')}"
							>
								<img :src="form.video_img_url" style="width:100%;" />
							</div>
							<div v-if="form.video_img!=form.prev_video_img && form.prev_video_img!=null && action=='update'" class="text-center text-muted">
								<i class="fa fa-arrow-down fa-2x"></i>
							</div>
							<div>
								<div id="image-preview"
									class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
									style="background-size: contain;background-repeat: no-repeat;background-position: center;"
									:style="{'height':(form.video_img!=form.prev_video_img)?'300px':''}"
								>
									
								</div>
								<div v-if="form.video_img!=form.prev_video_img && form.prev_video_img!=null && action=='update'" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
							</div>
						</div>
					</div>
					<div v-if="form.category!=null && form.category.includes('_course')" class="form-floating mb-4">
						<select id="module" name="module" v-model="form.module" class="form-control">
							<option value="0">Main Module</option>
							<option v-for="(mod,m_index) in cModules()" :value="mod.id">{{mod.title}}</option>
						</select>
						<label class="form-label" for="module">Module</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.author" id="author" name="author" class="form-control" placeholder="Author" />
						<label class="form-label" for="author">Author</label>
					</div>
					<div v-if="form.module>0" class="form-floating mb-4">
						<input type="number" v-model="form.video_seq" id="video_seq" name="video_seq" class="form-control" placeholder="video_seq" />
						<label class="form-label" for="video_seq">Video Sequence</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.video_mins" id="video_mins" name="video_mins" class="form-control" placeholder="Video Mins" />
						<label class="form-label" for="video_mins">Video Mins</label>
					</div>
					<div v-if="form.category!=null && !form.category.includes('_course') && !form.category.includes('_feature')" class="form-group mb-4">
						<label class="form-label" for="is_featured">Is Live?</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_live"
									id="is_live_on"
									name="is_live"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_live_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_live"
									id="is_live_off"
									name="is_live"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_live_off">OFF</label>
							</div>
						</div>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.start_datetime"
							:config="{
								enableTime: true,
								altInput: true,
								altFormat: 'M j, Y h:i K',
								dateFormat: 'Y-m-d H:i:s',
							}"
							class="form-control"
							:class="
								form.errors.start_datetime
									? 'flatpickr-input is-invalid border-danger'
									: 'flatpickr-input'
							"
						/>
						<label class="form-label" for="start_datetime">Start DateTime</label>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.end_datetime"
							:config="{
								enableTime: true,
								altInput: true,
								altFormat: 'M j, Y h:i K',
								dateFormat: 'Y-m-d H:i:s',
							}"
							class="form-control"
							:class="
								form.errors.end_datetime
									? 'flatpickr-input is-invalid border-danger'
									: 'flatpickr-input'
							"
						/>
						<label class="form-label" for="end_datetime">End DateTime</label>
					</div>
					<div v-if="form.category!='home_video_feature' && form.is_live==0" class="form-group mb-4">
						<label class="form-label" for="is_featured">Is feature?</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_featured"
									id="is_featured_on"
									name="is_featured"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_featured_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_featured"
									id="is_featured_off"
									name="is_featured"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_featured_off">OFF</label>
							</div>
						</div>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="is_active">Status</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_on"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_off"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_off">OFF</label>
							</div>
						</div>
					</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Video</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster';

export default {
	props: {
		category 		: String,
		categories 		: Object,
		courseModules 	: Object,
		live_exist 		: Number,
	},
	setup(props) {

		const toast = createToaster();

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal();
		}

		const cModules = ()=>{
							return props.courseModules.filter(function(data){
								if(form.id!=data.id)
								{
									return data;
								}
							})
						}
		
		const action = ref('add');

		const form = useForm({
			id 				: 0,
			video_id 		: null,
			category 		: null,
			module 			: 0,
			video_seq 		: 0,
			is_featured 	: 0,
			is_live 		: 0,
			is_active 		: 1,
			title 			: null,
			description 	: null,
			video_img 		: null,
			prev_video_img 	: null,
			video_img_url 	: null,
			author 			: null,
			author_img 		: null,
			video_mins 		: '00:00',
			start_datetime 	: null,
			end_datetime 	: null,
		})


		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.video_img = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.video_img = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.video_img = form.prev_video_img;
			clearUpload();
		}

		const getCourseModules = () => {
			Inertia.get(route('admin.video-library'),{
				category 	: props.category,
				course_cat 	: form.category
			},
			{
				preserveState: true,
				preserveScroll: true,
				only:['courseModules']
			});
		}

		const checkLive = () => {
			Inertia.get(route('admin.video-library'),{
				is_live 	: 1,
				id 			: form.id,
			},
			{
				preserveState: true,
				preserveScroll: true,
				only:['live_exist'],
				onSuccess:()=>{
					if(props.live_exist==1)
					{
						toast.show("Live is already exist ", { type: "error"});
					}else{

						if(action.value=='add')
						{
							addContent();
						}else
						{
							updateContent();	
						}
					}
				}
			});
		}

		const curData = reactive({});

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#video_img").val('');
		}

		const actionContent = ()=>{

			if(form.is_live==1)
			{
				checkLive();
			}else
			{
				if(action.value=='add')
				{
					addContent();
				}else
				{
					updateContent();	
				}
			}

		}

		const addContent = () => {
			form.post(route('admin.post.video-library'), {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['videoLibraries','courseModules','api_response'],
				onSuccess: () => {
					form.reset();
					clearUpload();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.post('video-library/'+form.id, {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['videoLibraries','courseModules','api_response'],
				onSuccess: () => {
					form.reset();
					clearUpload();
					toggleModal();
				},
			})
		}

		const setVideoContent = (_action,data)=>{

								clearUpload();

								Object.assign(curData,data);
								form.reset();

								if(_action=='update')
								{
									form.id 			= data.id;
									form.video_id 		= data.video_id;
									form.category 		= data.category;
									form.module 		= data.module;
									form.video_seq 		= data.video_seq;
									form.is_live 		= data.is_live;
									form.is_featured 	= data.is_featured;
									form.is_active 		= data.is_active;
									form.title 			= data.title;
									form.description 	= data.description;
									form.video_img 		= data.video_img;
									form.prev_video_img = data.prev_video_img;
									form.video_img_url 	= data.video_img_url;
									form.author 		= data.author;
									form.author_img 	= data.author_img;
									form.video_mins 	= data.video_mins;
									form.start_datetime = data.start_datetime;
									form.end_datetime 	= data.end_datetime;
								}
								
								action.value = _action;
							}

		watch(()=>form.category,(value)=>{
			if(value.includes('_course'))
			{
				getCourseModules();
			}
		})

		return {
			toast,
			form,
			onFileChange,
			clearUpload,
			removeUploadImage,
			getCourseModules,
			cModules,
			curData,
			modal,
			toggleModal,
			action,
			setVideoContent,
			checkLive,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>
